const templateElement = document.getElementById('color-text-template');
export default {
  template: templateElement ? templateElement.innerHTML : '',
  props: {
    active: {
      type: Object,
      required: true,
    },
  },
};
